/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { RolloutActionMetadata } from './rolloutActionMetadata';
import { RolloutNotificationActionResponse } from './rolloutNotificationActionResponse';
import { RolloutNotificationDetails } from './rolloutNotificationDetails';
import { RolloutTaskActionResponse } from './rolloutTaskActionResponse';
import { RolloutActionState } from './rolloutActionState';
import { RolloutActionType } from './rolloutActionType';
import { RolloutTaskDetails } from './rolloutTaskDetails';


/**
 * @type RolloutActionResponse
 * @export
 */
export type RolloutActionResponse = RolloutNotificationActionResponse | RolloutTaskActionResponse;

